import React from 'react';
import { Play } from 'lucide-react';
import type { SongItem } from '../../types/index';
import { Button } from '../ui/button'; // Assuming Button component is in ui folder

interface MusicCarouselProps {
  songs: SongItem[];
  title?: string;
}

const MusicCarousel: React.FC<MusicCarouselProps> = ({ songs, title = "Trending Music" }) => {
  if (!songs || songs.length === 0) {
    return null;
  }

  const handleViewMore = () => {
    console.log(`View More clicked for: ${title}`);
    // Future: Navigate to the full music page or section
  };

  return (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-2 px-4">
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {title}
        </h3>
        <Button variant="link" size="sm" onClick={handleViewMore} className="text-xs">
          View More
        </Button>
      </div>
      <div className="flex overflow-x-auto hide-scrollbar gap-3 px-4">
        {songs.map(song => (
          <div key={song.id} className="min-w-[150px] max-w-[150px]">
            <div className="aspect-square bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden relative group cursor-pointer">
              <img 
                src={song.cover_image || 'https://cdn.pixabay.com/photo/2015/05/15/14/50/concert-768722_1280.jpg'} 
                alt={song.title} 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-10 h-10 rounded-full bg-white bg-opacity-80 flex items-center justify-center">
                  <Play className="w-5 h-5 text-black" />
                </div>
              </div>
            </div>
            <p className="text-sm font-medium mt-1 truncate dark:text-white">{song.title}</p>
            <p className="text-xs text-gray-500 dark:text-gray-400 truncate">{song.artist}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MusicCarousel;
